// extracted by mini-css-extract-plugin
export default {"border":"CreateEvent_border__uAQOH","errorBox":"CreateEvent_errorBox__KzJpz","selectVendor":"CreateEvent_selectVendor__BDvjP","createBtn":"CreateEvent_createBtn__xPyzO"};